import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import AllProductsTable from 'components/tables/AllProductsTable/AllProductsTable';
import ProductSuggestionsTable from 'components/tables/ProductSuggestionsTable/ProductSuggestionsTable';
import useGlobalStyles from 'styles/globalStyles';


export default function AllProductsPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'All Products'}
            buttons={[
              // <CustomButton key='export' text='Export' color='primary' />
            ]}
          />
        </Box>

        <Box mt={3}>
          <AllProductsTable />
        </Box>
      </Container>
    
    </Box>
  )
}

